export const isMobileNumberValid = (value) => {
  if (value.length >= 10 && /^\d*$/.test(value)) {
    return true
  }
  return false
}

export const isEmailValid = (value) => {
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return true;
  } else {
    return false;
  }
}
export const isPanValid = (value) => {
  return /[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(value)
}
